import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-d3e60ea6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "user-new-articles" }
const _hoisted_2 = { class: "title mt40" }
const _hoisted_3 = ["href"]
const _hoisted_4 = { class: "news-list" }
const _hoisted_5 = ["href"]
const _hoisted_6 = { class: "news-image" }
const _hoisted_7 = ["src"]
const _hoisted_8 = { class: "img-txt" }
const _hoisted_9 = { class: "txt p-text" }
const _hoisted_10 = { class: "send-date" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_subtitle = _resolveComponent("subtitle")!
  const _component_fav_button = _resolveComponent("fav-button")!
  const _component_infinite_loading_content = _resolveComponent("infinite-loading-content")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_subtitle, {
        icon: "D",
        text: "新着のプレスリリース"
      }),
      (!_ctx.enableInfiniteLoad)
        ? (_openBlock(), _createElementBlock("a", {
            key: 0,
            class: "list",
            href: `/corporation/${_ctx.userAccountId}/articles`
          }, "一覧はこちら", 8, _hoisted_3))
        : _createCommentVNode("", true)
    ]),
    _createVNode(_component_infinite_loading_content, { onOnLoading: _ctx.onLoading }, {
      list: _withCtx(() => [
        _createElementVNode("ul", _hoisted_4, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.articles, (article, index) => {
            return (_openBlock(), _createElementBlock("li", {
              class: _normalizeClass(["news-item", `test-news-item${index}`]),
              key: article.articleId
            }, [
              _createElementVNode("a", {
                href: `/pressrelease/${article.articleId}`
              }, [
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("img", {
                    src: _ctx.imageUrl(article),
                    alt: ""
                  }, null, 8, _hoisted_7)
                ]),
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("p", _hoisted_9, _toDisplayString(article.title), 1),
                  _createElementVNode("p", _hoisted_10, _toDisplayString(_ctx.showSendDate(article.sendDate)), 1)
                ])
              ], 8, _hoisted_5),
              _createVNode(_component_fav_button, {
                reader: _ctx.reader,
                "article-ids": _ctx.favedArticleIds,
                "article-id": article.articleId
              }, null, 8, ["reader", "article-ids", "article-id"])
            ], 2))
          }), 128))
        ])
      ]),
      _: 1
    }, 8, ["onOnLoading"])
  ]))
}